export default __webpack_public_path__ + "static/discover-b7a994039b0a0aac93dcbee6eb2ada97.png";